import { UpdateOfficeSetupAdapters } from '../adapters';
import { updateOfficeInfo } from '../clients/UpdateOfficeInfo';
import { updateUserEducation } from '../clients/UpdateUserEducation';
import { UpdateOfficeSetupApiError } from '../errors';
import type { IUpdateOfficeSetupRequest } from '../types/UpdateOfficeSetup';

interface IUpdateOfficeSetupArgs {
  input: IUpdateOfficeSetupRequest;
  existingSpecialtiesAndProcedures: Record<string, string[]>;
}

const updateOfficeSetup = async ({
  input,
  existingSpecialtiesAndProcedures,
}: IUpdateOfficeSetupArgs): Promise<void> => {
  try {
    await updateOfficeInfo(UpdateOfficeSetupAdapters.toUpdateOfficeInfoPayload(input));
    await updateUserEducation(
      UpdateOfficeSetupAdapters.toUpdateUserEducationPayload(
        input,
        existingSpecialtiesAndProcedures,
      ),
    );
  } catch (error) {
    const typedError = UpdateOfficeSetupApiError.fromAxiosError(error);
    throw typedError ?? error;
  }
};

export const UpdateOfficeSetupService = { updateOfficeSetup };
